<!-- @format -->

<ng-container *transloco="let t">
  <fudis-expandable [level]="2" [title]="t('FREE_EDIT.COURSE_UNIT_EXPANDABLE.TITLE')" [closed]="false">
    <ng-template fudisExpandableContent>
      <fudis-heading [level]="3">{{ t("FREE_EDIT.COURSE_UNIT_EXPANDABLE.ADD_COURSE_UNITS") }}</fudis-heading>
      <sis-course-unit-search-select
        [cooperationNetworkIds]="cooperationNetworkIds"
        [currentUniversityOrgId]="currentUniversityOrgId"
        [crossStudyFeaturesEnabled]="crossStudyFeaturesEnabled"
        [curriculumPeriodIds]="curriculumPeriodIds"
        [excludedCourseUnitIds]="getCourseUnitIdsExcludedFromSearch()"
        (updateSelected)="selectCourseUnitFromSelectList($event)" />
      <div class="sis-pt-sm" *ngFor="let courseUnit of allCourseUnits">
        <sis-plan-structure-course-unit
          [courseUnit]="courseUnit"
          [planStateObject]="planStateObject"
          [planData]="planData"
          [headingLevel]="4"
          [action]="'select-to-plan'"
          [selected]="validatablePlan.isCourseUnitInPlan(courseUnit)"
          (actionChange)="
            handleToggle({
              courseUnit: courseUnit,
              isInPlan: validatablePlan.isCourseUnitInPlan(courseUnit),
            })
          ">
        </sis-plan-structure-course-unit>
      </div>
    </ng-template>
  </fudis-expandable>
</ng-container>
